<template>
    <header class="crud-header-system">

      <div class="flex flex-row">
        <nav v-if="canGoBack || canGoBackToNav" class="mt-1 mr-5 hidden-desktop">
            <a v-if="canGoBack" href="#" title="Back To List" @click.prevent="backEvent()"
               class="text-xl text-brand hover:text-brand-light"><i class="fa fa-chevron-left"></i></a>
            <a v-if="canGoBackToNav" href="#" title="Back To Item" @click.prevent="backToNav()"
               class="text-xl text-brand hover:text-brand-light"><i class="fa fa-chevron-left"></i></a>
        </nav>

        <heading size="medium" :title="title" />

        <aside class="flex space-x-4 mt-1 flex-row ml-auto">
            <a v-if="canEdit" href="#" class="text-xl text-brand" title="Edit" @click.prevent="editEvent()">
              <i class="fas fa-pencil"></i>
            </a>
            <a v-if="canDelete" href="#" class="text-xl text-brand" title="Delete" @click.prevent="deleteEvent()">
              <i class="fas fa-trash"></i>
            </a>
        </aside>
      </div>

    </header>
</template>

<script>
    export default {
        props: ['title', 'canDelete', 'canEdit', 'canGoBack', 'item', 'canGoBackToNav'],
        data() {
            return {}
        },
        watch: {},
        computed: {
            name() {
                return this.$parent.name;
            }
        },
        methods: {
            deleteEvent() {
                eventBus.$emit('crud-delete-item-' + this.name, this.item);
            },
            editEvent() {
                eventBus.$emit('crud-edit-item-' + this.name, this.item);
            },
            backEvent() {
                eventBus.$emit('crud-back-' + this.name, this.item);
            },
            backToNav() {
                eventBus.$emit('crud-back-to-nav-' + this.name);
            }
        },
        mounted() {

        }
    }
</script>
